module.exports = __webpack_public_path__ + "img/2.c262311e.svg";